import React from "react";
import WhatsappGroupList from "../../../UI/Groups/Whatsapp/View/WhatsappGroupList";

const WhatsappGroups = () => {
  return (
    <div>
      <WhatsappGroupList />
    </div>
  );
};

export default React.memo(WhatsappGroups);
